import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DefaultStyles from '@shared/components/core/structure/DefaultStyles';
import { ThemeContextLoader } from '@shared/components/loading/ThemeContextLoader';
import { useEditProfileContainerSetup } from '@shared/hooks/state/EditProfileContainer';
import Layout from 'admin/pages/layout';

const AppWithProviders = () => {
    (window as any).ADMIN_ENVIRONMENT = 'true';
    (window as any).commandHandlers = [];
    (window as any).commandMacroHandler = [];
    useEditProfileContainerSetup();

    return (
        <ThemeContextLoader>
            <DefaultStyles>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Layout />
                </LocalizationProvider>
            </DefaultStyles>
        </ThemeContextLoader>
    );
};

export default AppWithProviders;
